import { useRequestHeaders, useState } from '#app'
import { onMounted } from 'vue'
import { useDebounceFn, useEventListener } from '@vueuse/core'

const MOBILE_UA_RE = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i

function detectMobileFromUserAgent(userAgent = '') {
  return MOBILE_UA_RE.test(userAgent)
}

/**
 * SSR：User-Agent / Client Hints（不用视口宽度）。
 * 客户端水合首帧与 SSR payload 一致；挂载后再按 innerWidth 校正。
 */
function detectMobileOnServer() {
  const headers = useRequestHeaders([
    'user-agent',
    'sec-ch-ua-mobile',
    'sec-ch-viewport-width',
  ])
  if (headers['sec-ch-ua-mobile'] === '?1') return true
  const viewportWidth = Number.parseInt(headers['sec-ch-viewport-width'] || '', 10)
  if (viewportWidth > 0 && viewportWidth < 768) return true
  return detectMobileFromUserAgent(headers['user-agent'] || '')
}

/**
 * 与 SSR 首帧一致的视口判断（useState 同源）。
 * 布局壳层请配合 `layoutShellReady`：挂载前勿切换 mobile/desktop 两套 DOM。
 */
export function useHydrationSafeMobile(breakpointPx = 768) {
  const stateKey = `lip-is-mobile-${breakpointPx}`

  const isMobile = useState(stateKey, () => {
    if (import.meta.server) {
      return detectMobileOnServer()
    }
    /** 客户端首帧勿读 innerWidth，须与 SSR payload 一致，挂载后再 sync */
    return false
  })

  function syncIsMobileFromWindow() {
    if (!import.meta.client || typeof window === 'undefined') return
    isMobile.value = window.innerWidth < breakpointPx
  }

  onMounted(() => {
    syncIsMobileFromWindow()
    const onResize = useDebounceFn(syncIsMobileFromWindow, 120)
    useEventListener(window, 'resize', onResize, { passive: true })
  })

  return { isMobile, syncIsMobileFromWindow }
}
